import {UnderlyingStatistics} from "../models/UnderlyingStatistics";
import {IHttpService} from "angular";
import {CodeAndExchange} from "../../instruments/types/CodeAndExchange";

export class TradingAlertStatisticsService {

    public static id = "tradingAlertStatisticsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async for(security: CodeAndExchange): Promise<UnderlyingStatistics> {
        const url = `/tradefloor/api/trading-alerts/statistics/${security.code}/${security.exchange}`;
        const response = await this.$http.get<UnderlyingStatistics>(url);
        return response.data!;
    }
}
